export type RecognitionRate = {
	brandUser: number;
	brandNoneUser: number;
	categoryNoneUser: number;
};

export type Constant = {
	c1: number;
	c2: number;
	c3: number;
};

export type PurchaseIntentSoreBig = {
	brandUser: Big;
	brandNoneUser: Big;
	categoryNoneUser: Big;
};

export type UserSize = {
	brandUser: number;
	brandNoneUser: number;
	categoryNoneUser: number;
};

export type TrialResponse = {
	// A. トライアル率の計算
	/** ブランドユーザのトライアル率 */
	brandUserTrialRate: number;
	/** ブランドノンユーザのトライアル率 */
	brandNoneUserTrialRate: number;
	/** カテゴリノンユーザのトライアル率 */
	categoryNoneUserTrialRate: number;
	// B. トライアル購入数量の計算
	/** ブランドユーザのトライアル購入数量  */
	brandUserTrial: number;
	/** ブランドノンユーザのトライアル購入数量 */
	brandNoneUserTrial: number;
	/** カテゴリノンユーザのトライアル購入数量 */
	categoryNoneUserTrial: number;
	// C. トライアル数量の合計
	/** トライアル数量の合計 */
	trial: number;
};

export type TrialBigResponse = {
	[key in keyof Omit<TrialResponse, "purchaseIntent">]: Big;
};
